import styled from '@emotion/styled'

const DisplayH1 = styled.h1(({ theme }) => ({
  color: theme.colors.texts.textHeading,
  fontFamily: theme.fonts.families.headline,
  fontSize: '42px',
  fontWeight: 300,
  letterSpacing: '2.1px',
  lineHeight: '46px',
}))

export default DisplayH1
